import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, message, Select, Spin } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import { ReloadOutlined, SaveOutlined } from "@ant-design/icons";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import {
  getDepartmentTradeTypeApi,
  getTradeTypeApi,
} from "../../../services/vendorMaster";

export const TriggerForm = () => {
  const {
    // getDivision,
    // division,
    getDepartment,
    department,
    getTriggerList,
    triggerVendorSave,
    getCategory,
    category,
  } = useVendorMasterStore();
  const initialData = {
    vendorGUID: null,
    divisionName: null,
    divisionCode: null,
    departmentCode: null,
    departmentName: null,
    vendorType: null,
    vendorName: null,
    email: null,
  };
  const [localDepartment, setLocalDepartment] = useState([]);
  const [vendorType, setVendorType] = useState([]);
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  console.log("formData", formData);
  // const vendorType = ["Trade"];

  useEffect(() => {
    // getDivision();
    getTriggerList();
    getCategory();
    fetchType();
    fetchDepartmentLocal();
  }, []);
  useEffect(() => {
  if (formData.vendorType === "ZAEX") {
    setFormData((prev) => ({
      ...prev,
      divisionCode: null,
      divisionName: null,
       departmentCode: null,
    departmentName: null,
      
    }));
  }
}, [formData.vendorType]);

  const isZlocVendor = formData.vendorType === "ZAEX";

  const handleInputChange = useCallback(
    (field, value) => {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));

      if (errors[field]) {
        setErrors((prev) => ({
          ...prev,
          [field]: "",
        }));
      }
    },
    [errors],
  );

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrors((prev) => ({
        ...prev,
        email: "Invalid email format",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        email: "",
      }));
    }
  };
  const fetchType = async () => {
    try {
      setLoading(true);
      const response = await getTradeTypeApi();
      setVendorType(response?.Data);
    } catch (error) {
      console.error("Department fetch error:", error);
      message.error("Failed to load departments!");
    } finally {
      setLoading(false);
    }
  };
  const fetchDepartmentLocal = async () => {
    try {
      setLoading(true);
      const response = await getDepartmentTradeTypeApi();
      setLocalDepartment(response?.Data);
    } catch (error) {
      console.error("Department fetch error:", error);
      message.error("Failed to load departments!");
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartment = async (divisionCode) => {
    if (!divisionCode) return;

    try {
      setLoading(true);
      await getDepartment(divisionCode);
    } catch (error) {
      console.error("Department fetch error:", error);
      message.error("Failed to load departments!");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData(initialData);
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!isZlocVendor && !formData.divisionCode)
    newErrors.divisionCode = "Division is required";
    if (!formData.departmentCode)
      newErrors.departmentCode = "Department is required";
    if (!formData.vendorType) newErrors.vendorType = "Vendor Type is required";
    if (!formData.vendorName) newErrors.vendorName = "Vendor Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    // Remove unwanted fields from submission
    const payload = {
      vendorGUID: null,
      division: formData.divisionCode,
      department: formData.departmentCode,
      vendorType: formData.vendorType,
      vendorName: formData.vendorName.toUpperCase(),
      emailID: formData.email.toUpperCase(),
    };
    if (!validateForm()) {
      message.error("Please fix the validation errors before submitting.");
      return;
    }
    try {
      setLoading(true);
      await triggerVendorSave(payload);

      await getTriggerList();
      handleReset();
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error(
        error?.message || "Failed to save vendor. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <Row justify="center" style={{ marginTop: "0.5rem" }}>
        <Col
          xl={{ size: 3, offset: 9 }}
          md={{ size: 8 }}
          sm={{ size: 12 }}
          xs={{ size: 20 }}
          style={{ textAlign: "center" }}
        >
          <Button
            type="primary"
            icon={<SaveOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#52c41a", // elegant green
              borderColor: "#52c41a",
              boxShadow: "0 2px 6px rgba(82, 196, 26, 0.3)",
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            Send Request
          </Button>

          <Button
            icon={<ReloadOutlined />}
            size="large"
            style={{
              borderColor: "#ff1818ff",
              color: "#ff1818ff",
            }}
            onClick={handleReset}
          >
            Reset
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Vendor Type"} isImportnt={false} />
          <Select
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={vendorType.map((t) => ({
              label: t.VendorTypeName,
              value: t.VendorTypeCode,
            }))}
            value={formData.vendorType}
            onChange={(val) => handleInputChange("vendorType", val)}
          />
          {errors?.vendorType && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.vendorType}
            </span>
          )}
        </Col>
        {!isZlocVendor && (
          <Col xl={3} md={6}>
            <CustomLabel children={"Divison"} isImportnt={false} />
            <Select
              id="roletype"
              placeholder="Select "
              allowClear
              showSearch
              options={
                Array.isArray(category)
                  ? category.map((item) => ({
                      label: item.DivisionName,
                      value: item.Division,
                    }))
                  : []
              }
              // options={division.map((s) => ({
              //   label: s.DivisionName,
              //   value: s.Division,
              // }))}
              value={formData?.divisionCode}
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              onChange={(val, option) => {
                handleInputChange("divisionCode", val);
                handleInputChange("divisionName", option?.label);
                handleInputChange("departmentName", null);
                handleInputChange("departmentCode", null);
                fetchDepartment(val);
              }}
            />
            {errors?.divisionCode && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.divisionCode}
              </span>
            )}
          </Col>
        )}
        <Col xl={3} md={6}>
          <CustomLabel children={"Department"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            // options={department.map((d) => ({
            //   label: d.DepartmentName,
            //   value: d.Department,
            // }))}
            options={
              isZlocVendor
                ? localDepartment.map((d) => ({
                    label: d.DepartmentName,
                    value: d.DepartmentCode,
                  }))
                : department.map((d) => ({
                    label: d.DepartmentName,
                    value: d.Department,
                  }))
            }
            value={formData.departmentCode}
            onChange={(val, opt) => {
              handleInputChange("departmentCode", val);
              handleInputChange("departmentName", opt.label);
            }}
          />
          {errors?.departmentCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.departmentCode}
            </span>
          )}
        </Col>
      </Row>
      <Row>
        <Col xl={6} lg={6} md={6} sm={12}>
          <CustomLabel children={"Vendor name"} isImportnt={false} />
          <Input
            type="text"
            placeholder="Enter Vendor name"
            size="medium"
            style={{ textTransform: "uppercase" }}
            value={formData.vendorName}
            onChange={(e) => handleInputChange("vendorName", e.target.value)}
          />
          {errors?.vendorName && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.vendorName}
            </span>
          )}
        </Col>

        <Col xl={6} lg={6} md={6} sm={12}>
          <CustomLabel children={"Email"} isImportnt={false} />
          <Input
            name="vendorname"
            id="vendorname"
            type="email"
            placeholder="Enter Email"
            size="medium"
            style={{ textTransform: "uppercase" }}
            value={formData.email}
            onChange={(e) => {
              handleInputChange("email", e.target.value);
              validateEmail(e.target.value.toUpperCase());
            }}
          />
          {errors.email && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.email}
            </span>
          )}
        </Col>
      </Row>
    </>
  );
};
